import { InjectionToken, Provider, Type } from '@angular/core';
import { SEQUENCE_SERIES_PRESETS, SequenceSeriesComponent } from '@examdojo/math-widget';
import merge from 'lodash/merge';

export interface CustomComponentRegistryEntry {
  component: Type<unknown>;
  presets?: Record<string, Record<string, unknown>>;
}

export type CustomComponentRegistry = Map<string, CustomComponentRegistryEntry>;

export const CUSTOM_COMPONENT_REGISTRY = new InjectionToken<CustomComponentRegistry>('CUSTOM_COMPONENT_REGISTRY');

export const DEFAULT_CUSTOM_COMPONENTS: CustomComponentRegistry = new Map<string, CustomComponentRegistryEntry>([
  [
    'sequence-series-chart',
    {
      component: SequenceSeriesComponent,
      presets: SEQUENCE_SERIES_PRESETS,
    },
  ],
]);

export function provideCustomComponentRegistry(
  registry: CustomComponentRegistry = DEFAULT_CUSTOM_COMPONENTS,
): Provider {
  return { provide: CUSTOM_COMPONENT_REGISTRY, useValue: registry };
}

/**
 * Resolves a preset + overrides into a final inputs object.
 * If a preset is specified, deep-merges it with the inputs (overrides).
 * If no preset, returns inputs as-is.
 */
export function resolveComponentInputs(
  entry: CustomComponentRegistryEntry,
  preset: string | undefined,
  inputs: Record<string, unknown>,
): Record<string, unknown> {
  if (!preset || !entry.presets?.[preset]) {
    return inputs;
  }

  const base = structuredClone(entry.presets[preset]);
  return merge(base, inputs);
}
